module.exports = __webpack_public_path__ + "img/code44.176df742.png";